import React from "react";
import { evidenceOf } from "@/lib/evidence";

export const EvidenceBadge = ({ status, size = "sm", withDot = true }) => {
  const e = evidenceOf(status);
  const Icon = e.icon;
  const pad = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`evidence-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-mono font-medium uppercase tracking-wider border ${pad}`}
      style={{ backgroundColor: e.bg, borderColor: e.border, color: e.text }}
      title={e.desc}
    >
      {withDot && <Icon size={size === "lg" ? 14 : 11} strokeWidth={2.5} />}
      {e.label}
    </span>
  );
};
